<script lang="ts">
	import { page } from '$app/stores';
	import type { InputSelectProps, InputTextProps } from '@wiseed/wikit';
	import type { AppInputCheckboxProps } from '@app/types/Inputs';
	import type { GeocodeResult } from '@app/types/Here';
	import { t } from 'svelte-i18n';
	import Places from '../Places.svelte';
	import { InputText } from '@wiseed/wikit';
	import { InputCheckbox } from '@wiseed/wikit';
	import { InputHidden } from '@wiseed/wikit';
	import { slide } from 'svelte/transition';
	import InputSelectCountry from './InputSelectCountry.svelte';
	import InputSelect from '@app/components/inputs/AppInputSelect.svelte';
	import { FrenchCounty } from '@app/models/api/enums/FrenchCounty';
	import { onMount } from 'svelte';
	import { canBypassIdentityPatchRestriction } from '@app/utils/user';
	import { requiredRule } from '@wiseed/wikit';
	export let cityProps: InputTextProps;
	export let countyProps: InputSelectProps;
	export let countryCodeProps: InputSelectProps;
	export let postalCodeProps: InputTextProps;
	export let classNames: string = '';

	let notFoundProps: AppInputCheckboxProps = {
		label: $t('placeOfBirthNotFound'),
		boldLabel: true
	};

	let placesInputProps: InputTextProps = {
		label: cityProps.label
	};

	$: placesInputProps.required = !notFoundProps.checked;
	$: placesInputProps.disabled = notFoundProps.checked || cityProps.disabled;
	$: notFoundProps.checked && (placesInputProps.error = '');
	$: notFoundProps.disabled = cityProps.disabled;

	$: if (
		$page?.data?.user?.status?.walletOk &&
		canBypassIdentityPatchRestriction($page.data.user)
	) {
		notFoundProps.checked = true;
	}

	onMount(() => {
		const city = cityProps?.value ? `${cityProps.value}, ` : '';
		const county = countyProps?.value ? `${countyProps.value} ` : '';
		const postalCode = postalCodeProps?.value ? `${postalCodeProps.value}, ` : '';
		const countryCode = countryCodeProps?.value ? `${countryCodeProps.value}` : '';
		placesInputProps.value = `${city}${county}${postalCode}${countryCode}`;
	});
	$: countryCodeProps.validation = {
		rules: [requiredRule($t('forms.validators.required'))],
		valid: !!countryCodeProps.value
	};
	const onSelectValue = (e: GeocodeResult) => {
		let countyNumber;
		let countyValue;
		if (e.address?.postalCode) {
			countyNumber = e.address.postalCode.substring(0, 2);
			countyValue = Object.keys(FrenchCounty).find((key) =>
				FrenchCounty[key].startsWith(countyNumber)
			);
		}

		countyProps.value = countyValue;
		countyProps = countyProps;

		countryCodeProps.value = e.address.countryCode;
		countryCodeProps = countryCodeProps;

		postalCodeProps && (postalCodeProps.value = e.address.postalCode);
		postalCodeProps = postalCodeProps;

		cityProps.value = e.address.city;
		if (!e.address.city) notFoundProps.checked = true;
	};
</script>

<div class={`space-y-4 ${classNames}`}>
	<Places bind:inputProps={placesInputProps} onOptionClick={onSelectValue} placeTypes={'city'} />
	<InputCheckbox bind:props={notFoundProps} />
	{#if !notFoundProps.checked}
		<div class="hidden-inputs-block">
			<InputHidden bind:props={cityProps} />
			<InputHidden bind:props={countyProps} />
			<InputHidden bind:props={countryCodeProps} />
			<InputHidden bind:props={postalCodeProps} />
		</div>
	{:else}
		<div
			class="space-y-4 ml-3"
			in:slide|global={{ duration: 200 }}
			out:slide|global={{ duration: 200 }}
		>
			<InputText bind:props={cityProps} />
			<InputSelectCountry bind:props={countryCodeProps} />
			{#if countryCodeProps?.value === 'FRA'}
				<InputSelect bind:props={countyProps} />
			{/if}
			<InputText bind:props={postalCodeProps} />
		</div>
	{/if}
</div>
